import styled from "styled-components";

// new goals styles:
export const GoalsContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 25px;
    
    @media (orientation: landscape) {
        padding: 5% 10%;
    }
    
    @media (orientation: portrait) {
        padding: 10% 5%;
    }
    
    @media (max-width: 480px) {
        padding: 15px;
    }
`;

export const GoalsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-bottom: 29px;
    @media (min-width: 768px) {
        margin-bottom: 41px;
    }
`;

export const GoalsHeading = styled.div`
    color: #FFF;
    font-size: 22px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    cursor: default;
`

export const EditGoalsButton = styled.div`
    color: #FFF;
    text-align: center;
    font-size: 14px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    border-radius: 52px;
    border: 1px solid #FFF;
    padding: 4.8px 9.5px;
    cursor: pointer;
    @media (min-width: 768px) {
        font-weight: 500;
        padding: 11px 27px;
    }
`

export const SaveGoalsButton = styled.div`
    color: #FFF;
    text-align: center;
    font-size: 12px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-radius: 52px;
    padding: 4.8px 9.5px;
    cursor: pointer;
    background: ${props => props?.disabled ? '#4D4D4D' : '#09B41A'};
    @media (min-width: 768px) {
        font-weight: 500;
        padding: 11px 27px;
    }
`

export const CancelButtonGoals = styled.div`
    color: #FFF;
    text-align: center;
    font-size: 12px;
    font-family: Outfit;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    margin-right: 10px;
`

export const GoalItemsContainer = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin: 25px 0;
    
    @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }
    
    @media (min-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 24px;
    }
    
    @media (min-width: 1280px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 28px;
    }
    
    @media (max-width: 640px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
    
    @media (max-width: 480px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
        margin: 20px 0;
    }
`

//

export const StyledSwitch = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-direction: row;
    /* Glass effect */
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 4px 16px rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    padding: 8px;
    
    @media (max-width: 768px) {
        gap: 8px;
        padding: 6px;
        border-radius: 16px;
    }
    
    @media (max-width: 480px) {
        gap: 6px;
        padding: 5px;
        border-radius: 14px;
    }
`;

export const StyledSwitchOption = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 180px;
    height: 40px;
    padding: 0px 20px;
    background: ${(props) => 
        props.isSelected 
            ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%)'
            : 'transparent'
    };
    backdrop-filter: ${(props) => props.isSelected ? 'blur(10px)' : 'none'};
    -webkit-backdrop-filter: ${(props) => props.isSelected ? 'blur(10px)' : 'none'};
    border: ${(props) => 
        props.isSelected 
            ? '1px solid rgba(255, 255, 255, 0.3)' 
            : '1px solid transparent'
    };
    border-radius: 16px;
    font-family: 'Outfit', 'heroregular', sans-serif;
    font-style: normal;
    font-weight: ${(props) => props.isSelected ? '600' : '400'};
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 0.3px;
    color: ${(props) => props.isSelected ? 'rgba(255, 255, 255, 0.95)' : 'rgba(255, 255, 255, 0.7)'};
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: ${(props) => 
        props.isSelected 
            ? '0 4px 16px rgba(0, 0, 0, 0.15)' 
            : 'none'
    };
    
    &:hover {
        background: ${(props) => 
            props.isSelected 
                ? 'linear-gradient(135deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.2) 100%)'
                : 'linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.04) 100%)'
        };
        color: rgba(255, 255, 255, 0.9);
        border-color: ${(props) => 
            props.isSelected 
                ? 'rgba(255, 255, 255, 0.4)' 
                : 'rgba(255, 255, 255, 0.15)'
        };
    }
    
    @media (min-width: 1280px) {
        min-width: 230px;
        height: 44px;
        font-size: 20px;
        padding: 0px 24px;
    }
    
    @media (max-width: 768px) {
        min-width: 150px;
        height: 36px;
        font-size: 16px;
        padding: 0px 16px;
        border-radius: 14px;
    }
    
    @media (max-width: 480px) {
        min-width: 120px;
        height: 32px;
        font-size: 14px;
        padding: 0px 12px;
        border-radius: 12px;
    }
`;